module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='' + require("./serpHotelCard/serpHotelCard-js.html").apply(null,arguments) + '\r\n<div data-bind="html:componentsBanner"></div>\r\n<div data-bind="html:filterBanner"></div>\r\n<div data-bind="html:lotteryBanner"></div>\r\n';
}
return __p;
};
